import api from '@/api/shipments'

const state = () => ({
    shipments: {},
    selectedShipment: null,
    isFetching: false,
    shipmentUsers: [],
    shipmentUserWigs: [],
    shipmentManagersWithWigs: [],
    shipmentRecipients: [],
    isLoadingUsers: false,
    isLoadingWigs: false,
    isLoadingRecipients: false,
    filters: {
        status: '',
        search: '',
        dateFrom: '',
        dateTo: '',
        usmanager_id: null,
    },
    pagination: {
        currentPage: 1,
        perPage: 20,
        lastPage: 1,
        total: 0,
    },
    sort: '',
    shipmentItems: {},
    isFetchingShipmentItems: false,
    shipmentItemsFilters: {
        status: '',
        search: '',
        dateFrom: '',
        dateTo: '',
        usmanager_id: null,
    },
    shipmentItemsPagination: {
        current_page: 1,
        per_page: 20,
        last_page: 1,
        total: 0,
    },
    openShipmentReport: {
        wigs: [],
        total_price: 0,
        total_paid: 0,
        total_outstanding_balance: 0,
        pagination: {
            total: 0,
            per_page: 15,
            current_page: 1,
            last_page: 1,
        },
    },
    isFetchingOpenReport: false,
    usersWithShipments: [],
    isLoadingUsersWithShipments: false,
    isReturning: false,
})

export const getterTypes = {
    getAllShipments: 'getAllShipments',
    getSelectedShipment: 'getSelectedShipment',
    isFetching: 'isFetching',
    getFilters: 'getFilters',
    getPagination: 'getPagination',
    getSort: 'getSort',
    getShipmentUsers: 'getShipmentUsers',
    getShipmentUserWigs: 'getShipmentUserWigs',
    getShipmentManagersWithWigs: 'getShipmentManagersWithWigs',
    getShipmentRecipients: 'getShipmentRecipients',
    isLoadingUsers: 'isLoadingUsers',
    isLoadingWigs: 'isLoadingWigs',
    isLoadingRecipients: 'isLoadingRecipients',
    getShipmentItems: 'getShipmentItems',
    isFetchingShipmentItems: 'isFetchingShipmentItems',
    getShipmentItemsFilters: 'getShipmentItemsFilters',
    getShipmentItemsPagination: 'getShipmentItemsPagination',
    getOpenShipmentReport: 'getOpenShipmentReport',
    isFetchingOpenReport: 'isFetchingOpenReport',
    getUsersWithShipments: 'getUsersWithShipments',
    isLoadingUsersWithShipments: 'isLoadingUsersWithShipments',
    isReturning: 'isReturning',
}

export const actionTypes = {
    fetchShipments: '[shipments] Fetch shipments',
    fetchShipmentById: '[shipments] Fetch shipment by id',
    createShipment: '[shipments] Create shipment',
    fetchShipmentUsers: '[shipments] Fetch shipment users',
    fetchShipmentUserWigs: '[shipments] Fetch shipment user wigs',
    fetchShipmentUsersWithWigs: '[shipments] Fetch shipment users with wigs',
    resetShipmentManagersWithWigs:
        '[shipments] Reset shipment managers with wigs',
    fetchShipmentRecipients: '[shipments] Fetch shipment recipients',
    resetShipmentRecipients: '[shipments] Reset shipment recipients',
    updateWigBarcode: '[shipments] Update wig barcode',
    setFilters: '[shipments] Set filters',
    setPagination: '[shipments] Set pagination',
    setSort: '[shipments] Set sort',
    resetFilters: '[shipments] Reset filters',
    fetchShipmentItems: '[shipments] Fetch shipment items',
    setShipmentItemsFilters: '[shipments] Set shipment items filters',
    setShipmentItemsPagination: '[shipments] Set shipment items pagination',
    fetchOpenShipmentReport: '[shipments] Fetch open shipment report',
    fetchUsersWithShipments: '[shipments] Fetch users with shipments',
    returnShipmentItems: '[shipments] Return shipment items',
    bulkReturnShipmentItems: '[shipments] Bulk return shipment items',
}

const mutations = {
    setShipments(state, data) {
        const responseData = data?.data || data
        const shipments = responseData?.shipments || []
        const pagination = responseData?.pagination || state.pagination

        state.shipments = {
            shipments: shipments || [],
            pagination: {
                currentPage: pagination.currentPage || 1,
                lastPage: pagination.lastPage || 1,
                perPage: pagination.perPage || 20,
                total: pagination.total || 0,
            },
        }
    },
    setSelectedShipment(state, shipment) {
        const responseData = shipment?.data || shipment
        state.selectedShipment = responseData?.shipment || responseData || null
    },
    setFetching(state, isFetching) {
        state.isFetching = isFetching
    },
    setFilters(state, filters) {
        state.filters = { ...state.filters, ...filters }
    },
    setPagination(state, pagination) {
        state.pagination = { ...state.pagination, ...pagination }
    },
    setSort(state, sort) {
        state.sort = sort
    },
    resetFilters(state) {
        state.filters = {
            status: '',
            search: '',
            dateFrom: '',
            dateTo: '',
            usmanager_id: null,
        }
        state.pagination = {
            ...state.pagination,
            currentPage: 1,
        }
        state.sort = ''
    },
    setShipmentUsers(state, users) {
        const responseData = users?.data || users
        state.shipmentUsers = Array.isArray(responseData) ? responseData : []
    },
    setShipmentUserWigs(state, wigs) {
        const responseData = wigs?.data || wigs
        state.shipmentUserWigs = Array.isArray(responseData) ? responseData : []
    },
    setShipmentManagersWithWigs(state, managersWithWigs) {
        const responseData = managersWithWigs?.data || managersWithWigs
        state.shipmentManagersWithWigs = Array.isArray(responseData)
            ? responseData
            : []
        const flattenedWigs = []
        if (Array.isArray(responseData)) {
            responseData.forEach((manager) => {
                if (Array.isArray(manager.wigs)) {
                    manager.wigs.forEach((wig) => {
                        flattenedWigs.push({
                            ...wig,
                            managerId: manager.id,
                            managerNickName: manager.nickName,
                        })
                    })
                }
            })
        }
        state.shipmentUserWigs = flattenedWigs
    },
    setLoadingUsers(state, isLoading) {
        state.isLoadingUsers = isLoading
    },
    setLoadingWigs(state, isLoading) {
        state.isLoadingWigs = isLoading
    },
    setShipmentRecipients(state, recipients) {
        const responseData = recipients?.data || recipients
        state.shipmentRecipients = Array.isArray(responseData)
            ? responseData
            : []
    },
    setLoadingRecipients(state, isLoading) {
        state.isLoadingRecipients = isLoading
    },
    setShipmentItems(state, data) {
        const responseData = data
        const items = responseData?.data || []
        const pagination = responseData?.meta || state.shipmentItemsPagination

        state.shipmentItems = {
            items: items || [],
            pagination: {
                currentPage: pagination.current_page || 1,
                lastPage: pagination.last_page || 1,
                perPage: pagination.per_page || 20,
                total: pagination.total || 0,
            },
        }
    },
    setFetchingShipmentItems(state, isFetching) {
        state.isFetchingShipmentItems = isFetching
    },
    setShipmentItemsFilters(state, filters) {
        const updatedFilters = { ...state.shipmentItemsFilters, ...filters }
        if (
            filters.status === '' ||
            filters.status === null ||
            filters.status === undefined
        ) {
            updatedFilters.status = ''
        }
        state.shipmentItemsFilters = updatedFilters
    },
    setShipmentItemsPagination(state, pagination) {
        state.shipmentItemsPagination = {
            ...state.shipmentItemsPagination,
            ...pagination,
        }
    },
    setOpenShipmentReport(state, data) {
        const responseData = data?.data || data
        state.openShipmentReport = {
            wigs: responseData?.wigs || [],
            total_price: responseData?.total_price || 0,
            total_paid: responseData?.total_paid || 0,
            total_outstanding_balance: responseData?.total_outstanding_balance || 0,
            pagination: responseData?.pagination || {
                total: 0,
                per_page: 15,
                current_page: 1,
                last_page: 1,
            },
        }
    },
    setFetchingOpenReport(state, isFetching) {
        state.isFetchingOpenReport = isFetching
    },
    setUsersWithShipments(state, users) {
        const responseData = users?.data || users
        state.usersWithShipments = Array.isArray(responseData) ? responseData : []
    },
    setLoadingUsersWithShipments(state, isLoading) {
        state.isLoadingUsersWithShipments = isLoading
    },
    setReturning(state, isReturning) {
        state.isReturning = isReturning
    },
}

const getters = {
    [getterTypes.getAllShipments]: ({ shipments }) => shipments,
    [getterTypes.getSelectedShipment]: ({ selectedShipment }) =>
        selectedShipment,
    [getterTypes.isFetching]: ({ isFetching }) => isFetching,
    [getterTypes.getFilters]: ({ filters }) => filters,
    [getterTypes.getPagination]: ({ pagination }) => pagination,
    [getterTypes.getSort]: ({ sort }) => sort,
    [getterTypes.getShipmentUsers]: ({ shipmentUsers }) => shipmentUsers,
    [getterTypes.getShipmentUserWigs]: ({ shipmentUserWigs }) =>
        shipmentUserWigs,
    [getterTypes.getShipmentManagersWithWigs]: ({ shipmentManagersWithWigs }) =>
        shipmentManagersWithWigs,
    [getterTypes.getShipmentRecipients]: ({ shipmentRecipients }) =>
        shipmentRecipients,
    [getterTypes.isLoadingUsers]: ({ isLoadingUsers }) => isLoadingUsers,
    [getterTypes.isLoadingWigs]: ({ isLoadingWigs }) => isLoadingWigs,
    [getterTypes.isLoadingRecipients]: ({ isLoadingRecipients }) =>
        isLoadingRecipients,
    [getterTypes.getShipmentItems]: ({ shipmentItems }) => shipmentItems,
    [getterTypes.isFetchingShipmentItems]: ({ isFetchingShipmentItems }) =>
        isFetchingShipmentItems,
    [getterTypes.getShipmentItemsFilters]: ({ shipmentItemsFilters }) =>
        shipmentItemsFilters,
    [getterTypes.getShipmentItemsPagination]: ({ shipmentItemsPagination }) =>
        shipmentItemsPagination,
    [getterTypes.getOpenShipmentReport]: ({ openShipmentReport }) =>
        openShipmentReport,
    [getterTypes.isFetchingOpenReport]: ({ isFetchingOpenReport }) =>
        isFetchingOpenReport,
    [getterTypes.getUsersWithShipments]: ({ usersWithShipments }) =>
        usersWithShipments,
    [getterTypes.isLoadingUsersWithShipments]: ({ isLoadingUsersWithShipments }) =>
        isLoadingUsersWithShipments,
    [getterTypes.isReturning]: ({ isReturning }) => isReturning,
}

const actions = {
    [actionTypes.fetchShipments]({ commit, state }) {
        commit('setFetching', true)
        return new Promise((res, rej) => {
            const params = {
                page: state.pagination.currentPage,
                per_page: state.pagination.perPage,
            }

            if (state.filters.status) {
                params.status = state.filters.status
            }

            const searchTrimmed = state.filters.search?.trim()
            if (searchTrimmed && searchTrimmed.length > 0) {
                params.search = searchTrimmed
            }

            if (state.sort) {
                params.sort = state.sort
            }

            if (state.filters['created[from]']) {
                params['created[from]'] = state.filters['created[from]']
            }

            if (state.filters['created[to]']) {
                params['created[to]'] = state.filters['created[to]']
            }

            if (state.filters.usmanager_id) {
                params.usmanager_id = Number(state.filters.usmanager_id)
            }

            api.getShipments(params)
                .then((data) => {
                    commit('setShipments', data)
                    commit('setFetching', false)
                    res(data)
                })
                .catch((error) => {
                    commit('setFetching', false)
                    rej(error)
                })
        })
    },
    [actionTypes.fetchShipmentById]({ commit }, id) {
        commit('setFetching', true)
        return new Promise((res, rej) => {
            api.getShipmentById(id)
                .then((data) => {
                    commit('setSelectedShipment', data)
                    commit('setFetching', false)
                    res(data)
                })
                .catch((error) => {
                    commit('setFetching', false)
                    rej(error)
                })
        })
    },
    [actionTypes.createShipment]({ commit, dispatch }, payload) {
        commit('setFetching', true)
        return new Promise((res, rej) => {
            api.createShipment(payload)
                .then((data) => {
                    commit('setFetching', false)
                    if (data?.data?.shipment?.id) {
                        dispatch(
                            actionTypes.fetchShipmentById,
                            data.data.shipment.id
                        )
                    }
                    res(data)
                })
                .catch((error) => {
                    commit('setFetching', false)
                    rej(error)
                })
        })
    },
    [actionTypes.setFilters]({ commit, dispatch }, filters) {
        commit('setFilters', filters)
        commit('setPagination', { currentPage: 1 })
        dispatch(actionTypes.fetchShipments)
    },
    [actionTypes.setPagination]({ commit, dispatch }, pagination) {
        commit('setPagination', pagination)
        dispatch(actionTypes.fetchShipments)
    },
    [actionTypes.setSort]({ commit, dispatch }, sort) {
        commit('setSort', sort)
        commit('setPagination', { currentPage: 1 })
        dispatch(actionTypes.fetchShipments)
    },
    [actionTypes.resetFilters]({ commit, dispatch }) {
        commit('resetFilters')
        dispatch(actionTypes.fetchShipments)
    },
    [actionTypes.fetchShipmentUsers]({ commit }) {
        commit('setLoadingUsers', true)
        return new Promise((res, rej) => {
            api.getShipmentUsers()
                .then((data) => {
                    commit('setShipmentUsers', data)
                    commit('setLoadingUsers', false)
                    res(data)
                })
                .catch((error) => {
                    commit('setLoadingUsers', false)
                    rej(error)
                })
        })
    },
    [actionTypes.fetchShipmentUserWigs]({ commit }, userId) {
        commit('setLoadingWigs', true)
        commit('setShipmentUserWigs', []) // Clear previous wigs
        return new Promise((res, rej) => {
            api.getShipmentUserWigs(userId)
                .then((data) => {
                    commit('setShipmentUserWigs', data)
                    commit('setLoadingWigs', false)
                    res(data)
                })
                .catch((error) => {
                    commit('setLoadingWigs', false)
                    rej(error)
                })
        })
    },
    [actionTypes.fetchShipmentUsersWithWigs]({ commit }, senders) {
        commit('setLoadingWigs', true)
        return new Promise((res, rej) => {
            api.getShipmentUsersWithWigs(senders)
                .then((data) => {
                    commit('setShipmentManagersWithWigs', data)
                    commit('setLoadingWigs', false)
                    res(data)
                })
                .catch((error) => {
                    commit('setLoadingWigs', false)
                    rej(error)
                })
        })
    },
    [actionTypes.resetShipmentManagersWithWigs]({ commit }) {
        commit('setShipmentManagersWithWigs', [])
    },
    [actionTypes.fetchShipmentRecipients]({ commit }, params = {}) {
        commit('setLoadingRecipients', true)
        return new Promise((res, rej) => {
            api.getShipmentRecipients(params)
                .then((data) => {
                    commit('setShipmentRecipients', data)
                    commit('setLoadingRecipients', false)
                    res(data)
                })
                .catch((error) => {
                    commit('setLoadingRecipients', false)
                    rej(error)
                })
        })
    },
    [actionTypes.resetShipmentRecipients]({ commit }) {
        commit('setShipmentRecipients', [])
    },
    [actionTypes.updateWigBarcode]({ commit }, { wigId, form }) {
        commit('setFetching', true)
        return new Promise((res, rej) => {
            api.updateWigBarcode({ wigId, form })
                .then((data) => {
                    commit('setFetching', false)
                    res(data)
                })
                .catch((error) => {
                    commit('setFetching', false)
                    rej(error)
                })
        })
    },
    [actionTypes.fetchShipmentItems]({ commit, state }) {
        commit('setFetchingShipmentItems', true)
        return new Promise((res, rej) => {
            const params = {
                page: state.shipmentItemsPagination.currentPage,
                per_page: state.shipmentItemsPagination.perPage,
            }

            if (
                state.shipmentItemsFilters.status &&
                state.shipmentItemsFilters.status !== ''
            ) {
                params.status = Array.isArray(state.shipmentItemsFilters.status)
                    ? state.shipmentItemsFilters.status
                    : [state.shipmentItemsFilters.status]
            }

            const searchTrimmed = state.shipmentItemsFilters.search?.trim()
            if (searchTrimmed && searchTrimmed.length > 0) {
                params.search = searchTrimmed
            }

            if (state.shipmentItemsFilters.date_from) {
                params.date_from = state.shipmentItemsFilters.date_from
            }

            if (state.shipmentItemsFilters.date_to) {
                params.date_to = state.shipmentItemsFilters.date_to
            }

            if (state.shipmentItemsFilters.usmanager_id) {
                params.usmanager_id = Number(state.shipmentItemsFilters.usmanager_id)
            }

            api.getShipmentItems(params)
                .then((data) => {
                    commit('setShipmentItems', data)
                    commit('setFetchingShipmentItems', false)
                    res(data)
                })
                .catch((error) => {
                    commit('setFetchingShipmentItems', false)
                    rej(error)
                })
        })
    },
    [actionTypes.setShipmentItemsFilters]({ commit }, filters) {
        commit('setShipmentItemsFilters', filters)
        commit('setShipmentItemsPagination', { currentPage: 1 })
    },
    [actionTypes.setShipmentItemsPagination]({ commit }, pagination) {
        commit('setShipmentItemsPagination', pagination)
    },
    [actionTypes.fetchOpenShipmentReport]({ commit }, params) {
        commit('setFetchingOpenReport', true)
        return new Promise((res, rej) => {
            api.getOpenShipmentReport(params)
                .then((data) => {
                    commit('setOpenShipmentReport', data)
                    commit('setFetchingOpenReport', false)
                    res(data)
                })
                .catch((error) => {
                    commit('setFetchingOpenReport', false)
                    rej(error)
                })
        })
    },
    [actionTypes.fetchUsersWithShipments]({ commit }) {
        commit('setLoadingUsersWithShipments', true)
        return new Promise((res, rej) => {
            api.getUsersWithShipments()
                .then((data) => {
                    commit('setUsersWithShipments', data)
                    commit('setLoadingUsersWithShipments', false)
                    res(data)
                })
                .catch((error) => {
                    commit('setLoadingUsersWithShipments', false)
                    rej(error)
                })
        })
    },
    [actionTypes.returnShipmentItems]({ commit, dispatch }, { shipmentId, payload }) {
        commit('setReturning', true)
        return new Promise((res, rej) => {
            api.returnShipmentItems(shipmentId, payload)
                .then((data) => {
                    commit('setReturning', false)
                    if (shipmentId) {
                        dispatch(actionTypes.fetchShipmentById, shipmentId)
                    }
                    res(data)
                })
                .catch((error) => {
                    commit('setReturning', false)
                    rej(error)
                })
        })
    },
    [actionTypes.bulkReturnShipmentItems]({ commit, dispatch }, payload) {
        commit('setReturning', true)
        return new Promise((res, rej) => {
            api.bulkReturnShipmentItems(payload)
                .then((data) => {
                    commit('setReturning', false)
                    dispatch(actionTypes.fetchShipmentItems)
                    res(data)
                })
                .catch((error) => {
                    commit('setReturning', false)
                    rej(error)
                })
        })
    },
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
}
